<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title>
			<h2>Formy prawne</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>
		<v-dialog v-model="dialog" max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline"> Edycja formy prawnej</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 md6>
								<v-text-field disabled
									browser-autocomplete="off"
									v-model="editedItem.legalForm"
									label="Forma prawna"
									aria-label="legal form"
									for="legal-forms-view-legal-form"
									id="legal-forms-view-legal-form"
								></v-text-field>
							</v-flex>
							<v-flex xs12 md6>
								<v-select menu-props="{ 'closeOnClick': true }" label="Paragraf"
									aria-label="paragraph"
									v-model="editedItem.paragraph" :items="paragraphs"
									return-object
								>
									<template slot="item" slot-scope="data">
										{{ (data.item && data.item.number) || "Brak"}} {{ (data.item &&
											data.item.description) || "" }}
									</template>
									<template slot="selection" slot-scope="data">
										{{ (data.item && data.item.number) || "Brak"}}
									</template>
								</v-select>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="save">Zapisz</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-data-table
			hide-actions
			:headers="tableHeaders"
			:loading="loading"
			:items="legalForms">
			<template slot="items" slot-scope="props">
				<td>{{ props.item.legalForm }}</td>
				<td>{{ (props.item.paragraph && props.item.paragraph.number) || "-"}}</td>
				<td>{{ (props.item.paragraph && props.item.paragraph.description) || "-"}}</td>
				<td>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="editItem(props.item)" >
								<v-icon v-on="on">
									edit
								</v-icon>
							</v-btn>
						</template>
						<span>Edytuj</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Paragraph} from "../../../api/generated/Paragraph";

	export default {
		name: "LegalFormsView",

		data() {
			return {
				legalForms: [],
				paragraphs: [],
				dialog: false,
				loading: false,
				tableHeaders: [
					{
						text: "Forma prawna",
						value: "number",
						sortable: false,
					},
					{text: "Paragraf", value: "paragraph", sortable: false},
					{text: "Opis paragrafu", value: "description", sortable: false},
					{text: "Akcje", value: "actions", sortable: false},
				],
				editedItem: {},
				editedIndex: -1,
			};
		},

		methods: {
			editItem(item) {
				this.editedIndex = this.legalForms.indexOf(item);
				this.editedItem = Object.assign({}, item);
				this.dialog = true;
			},

			close() {
				this.dialog = false;
			},

			save() {
				Paragraph.putLegalFormParagraphEdit(this, this.editedItem, successResponse => {
					Object.assign(this.legalForms[this.editedIndex], this.editedItem);
					this.close();
					this.$messagesBus.$emit("success", "Forma prawna została pomyślnie zapisana", successResponse);
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się zapisać formy prawnej", errorResponse);
				});
			},
		},

		created () {
			Paragraph.getList(this, successResponse => {
					this.paragraphs = successResponse;
					this.paragraphs.unshift(null);
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się pobrać listy paragrafów", errorResponse);
				});

			Paragraph.getLegalFormParagraphList(this, successResponse => {
					this.legalForms = successResponse;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się pobrać listy form prawnych", errorResponse);
				});
		},
	};
</script>

<style scoped>

</style>
